import type { MtmWidgetProfile } from './types';

function isValidEmail(value: string | null | undefined) {
  return Boolean(value && value.length > 3 && value.includes('@'));
}

export function isMtmWidgetProfileComplete(profile: MtmWidgetProfile | null | undefined): boolean {
  if (!profile) {
    return false;
  }

  const email = profile.defaultValues.email ?? profile.userContext?.email;

  return Boolean(isValidEmail(email) && profile.firstName?.trim());
}

export function assertMtmWidgetProfileComplete(
  profile: MtmWidgetProfile | null | undefined,
): asserts profile is MtmWidgetProfile {
  if (!isMtmWidgetProfileComplete(profile)) {
    const missing: string[] = [];
    const email = profile?.defaultValues?.email ?? profile?.userContext?.email;

    if (!isValidEmail(email)) {
      missing.push('email');
    }
    if (!profile?.firstName?.trim()) {
      missing.push('fullName');
    }

    throw new Error(
      missing.length > 0
        ? `3DLOOK requires ${missing.join(', ')} before starting a scan.`
        : 'Complete profile is required before starting a 3DLOOK scan.',
    );
  }
}
